import './Logo.scss'

export default function Logo({color1 = '#778a99', color2 = '#778a99'}) {
	return (
		<svg
			version='1.1'
			width='36'
			height='36'
			viewBox='0 0 256 256'
		>
			<g
				className='g'
				transform='translate(245.83968871595334 255.24295719844355) rotate(180) scale(2.63 2.63) matrix(1 0 0 -1 0 90)'
			>
				<path
					d='M 48.705 68.059 c -0.814 0 -1.482 -0.652 -1.499 -1.471 c -0.016 -0.828 0.643 -1.513 1.471 -1.529 c 12.711 -0.25 23.053 -10.801 23.053 -23.52 c 0 -12.971 -10.553 -23.524 -23.524 -23.524 c -12.768 0 -23.32 10.383 -23.521 23.145 c -0.013 0.828 -0.701 1.474 -1.524 1.476 c -0.828 -0.013 -1.489 -0.695 -1.476 -1.524 c 0.228 -14.39 12.125 -26.097 26.521 -26.097 c 14.626 0 26.524 11.899 26.524 26.524 c 0 14.341 -11.661 26.237 -25.994 26.52 C 48.726 68.059 48.716 68.059 48.705 68.059 z'
					className='p1'
					fill={color1}
					transform=' matrix(1 0 0 1 0 0) '
					strokeLinecap='round'
				/>
				<path
					d='M 48.205 83.078 c -1.147 0 -2.311 -0.048 -3.458 -0.143 c -0.826 -0.068 -1.439 -0.793 -1.372 -1.618 c 0.068 -0.826 0.785 -1.432 1.619 -1.372 c 1.065 0.088 2.145 0.133 3.21 0.133 c 21.251 0 38.539 -17.288 38.539 -38.539 C 86.744 20.289 69.456 3 48.205 3 C 26.955 3 9.667 20.289 9.667 41.539 c 0 1.063 0.043 2.136 0.13 3.188 c 0.067 0.826 -0.547 1.55 -1.373 1.617 c -0.827 0.075 -1.549 -0.547 -1.618 -1.372 c -0.093 -1.133 -0.14 -2.288 -0.14 -3.433 C 6.667 18.634 25.301 0 48.205 0 s 41.539 18.634 41.539 41.539 C 89.744 64.443 71.109 83.078 48.205 83.078 z'
					className='p1'
					fill={color1}
					transform=' matrix(1 0 0 1 0 0) '
					strokeLinecap='round'
				/>
				<path
					d='M 52.847 51.91 c -0.54 0 -1.062 -0.292 -1.329 -0.804 c -0.385 -0.733 -0.102 -1.641 0.632 -2.024 c 2.816 -1.477 4.565 -4.367 4.565 -7.543 c 0 -4.692 -3.817 -8.51 -8.51 -8.51 c -3.268 0 -6.196 1.823 -7.64 4.757 c -0.366 0.743 -1.266 1.049 -2.008 0.683 c -0.743 -0.366 -1.049 -1.265 -0.683 -2.008 c 1.953 -3.967 5.912 -6.432 10.332 -6.432 c 6.347 0 11.51 5.163 11.51 11.51 c 0 4.295 -2.365 8.204 -6.173 10.199 C 53.32 51.855 53.082 51.91 52.847 51.91 z'
					className='p1'
					fill={color1}
					transform=' matrix(1 0 0 1 0 0) '
					strokeLinecap='round'
				/>
				<path
					d='M 10.884 90 c -0.384 0 -0.768 -0.146 -1.061 -0.439 l -9.128 -9.128 c -0.281 -0.281 -0.439 -0.663 -0.439 -1.061 s 0.158 -0.779 0.439 -1.061 L 16.81 62.197 l -8.16 -8.16 c -0.375 -0.374 -0.524 -0.919 -0.393 -1.432 c 0.131 -0.514 0.523 -0.919 1.031 -1.068 L 48.295 40.1 c 0.525 -0.155 1.095 -0.009 1.482 0.379 c 0.388 0.388 0.533 0.956 0.379 1.482 L 38.719 80.968 c -0.149 0.509 -0.555 0.9 -1.068 1.031 c -0.512 0.131 -1.058 -0.018 -1.432 -0.393 l -8.16 -8.16 L 11.944 89.561 C 11.651 89.854 11.268 90 10.884 90 z'
					className='p2'
					fill={color2}
					transform=' matrix(1 0 0 1 0 0) '
					strokeLinecap='round'
				/>
			</g>
		</svg>
	)
}
